module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2-left"
  }, [_c('a', {
    attrs: {
      "id": "ch01"
    }
  }), _c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_vm._v("One")])]), _c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "stickup"
  }, [_vm._v("W")]), _vm._v("hen Chris speaks, his hands flop around like dying fish on the deck of a ship. I try not to stare, but it’s impossible. They’re pale, scaly things, too small for his wrists, more like the hands of a kid than a man. He’s going on and on about how much progress he thinks we’ve made, about how I’m on my way toward health. I notice that he doesn’t say I’m healed. Everyone is always in recovery. No one is ever whole. I didn’t need six therapy sessions to tell me that I’ll never be whole again.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Mark, so what do you think?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Hearing my name, I lift my gaze and meet his eyes. “What?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How have these sessions been for you?”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_vm._v("I’m unsure how to respond. If I say they’ve been helpful, then ")]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("it’s as if I’m admitting that he’s been right—that everyone’s been right—and I’ve needed counseling. If I say they haven’t, he’ll write something like, "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Needs more time,")]), _vm._v(" and then I’ll have to waste additional hours of my life with this guy and his stupid fish hands.")])]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("I take a different approach. “It’s always good to talk things out.” Not that I’ve done any talking. I’ve basically repeated Chris’s phrases back to him, telling him what I think he wants to hear. It’s easy, especially with adults who think listening means nodding and taking notes and making assumptions. Assumptions like Chris made when we met. He took one look at me—male, Filipino, teen, beanie, white plugs, red T-shirt, jeans—and said, “What’s up?” as if he was excited to practice his teen vernacular. I held out my hand and said, “Pleased to meet you.” I didn’t want to be there, but I’d been raised to respect authority. My formality must have thrown him, because he gave a thin smile after shaking my hand and motioned for me to sit in the black leather chair facing his desk.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Chris’s brown eyes perk up at my response. I’ve probably made his day.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, yes, it is, Mark. I’m glad you can see that.” He folds his tiny hands on the desk in front of him. “I hope you’ll take the tools you’ve learned here and apply them with your family, your friends. Know that you’re not alone. I am always here if you need to talk.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I nod. Sure, at 110 bucks an hour.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("“Great.” Chris gets up, signaling that our session is done. “Can you send your father in on your way out?”")])]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("In the waiting room, Dad stands in front of a painting of an ocean.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Um, Chris wants you,” I say.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Dad glances at my eyes, then looks at the floor as he says, “Okay.” He pats my shoulder twice as he walks by, and closes the door to Chris’s office behind him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I stand in his place across from the picture. The sea is dark blue and streams of sunlight break through a patch in the clouds, illuminating the water, making it sparkle. A couple of birds fly across the horizon. A lighthouse sits atop a cliff directing a beam of light at a small sailboat in the corner of the canvas. The caption underneath reads: "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AFTER THE STORM")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("They say grief is an ocean measured in waves and currents, rocking and tossing you about like a boat stranded in the middle of the deep. But this is not true. Grief is a dull blade against the skin of your soul. It takes its time doing its work. Grief will slowly drive you crazy, until you try to sever yourself like some kind of wounded animal caught in a trap. You’d rather maim yourself and be free.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But you’ll never be free because you’ll always remember. I remember. I remember my twin sister, Grace. So I press up against the blade even harder.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c1c385f8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch01.vue
// module id = 63
// module chunks = 0